module.exports = __webpack_public_path__ + "26060e5f18fd4a45902496746c92c255.svg";